/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TextareaExampleRowsCols, TextareaExamplePlaceholder, TextareaExampleVertical, TextareaExampleStretched, TextareaExampleAutoresize, TextareaExampleMaxLength, TextareaExampleFormStatus, TextareaExampleDisabled, TextareaExampleSuffix} from 'Docs/uilib/components/textarea/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Textarea with rows and colds"
    }), "\n", _jsx(TextareaExampleRowsCols, {}), "\n", _jsx(_components.h3, {
      children: "Textarea with placeholder text"
    }), "\n", _jsx(TextareaExamplePlaceholder, {}), "\n", _jsx(_components.h3, {
      children: "Vertically placed label"
    }), "\n", _jsx(TextareaExampleVertical, {}), "\n", _jsx(_components.h3, {
      children: "Stretched horizontally placed label"
    }), "\n", _jsx(TextareaExampleStretched, {}), "\n", _jsx(_components.h3, {
      children: "Autoresize with max rows"
    }), "\n", _jsx(TextareaExampleAutoresize, {}), "\n", _jsx(_components.h3, {
      children: "Max length usage"
    }), "\n", _jsx(TextareaExampleMaxLength, {}), "\n", _jsx(_components.h3, {
      children: "With FormStatus failure message"
    }), "\n", _jsx(TextareaExampleFormStatus, {}), "\n", _jsx(_components.h3, {
      children: "Disabled textarea"
    }), "\n", _jsx(TextareaExampleDisabled, {}), "\n", _jsx(_components.h3, {
      children: "Textarea with a suffix"
    }), "\n", _jsx(TextareaExampleSuffix, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
